import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/telematikInfrastructureSigningMutationParams"
import {
  De_signTherapyPrescriptionDocumentWithTelematikInfrastructureInput,
  useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation as useDeSignTherapyPrescriptionWithTelematikInfrastructureMutationType,
} from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation.graphql"

const mutation = graphql`
  mutation useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation(
    $input: De_signTherapyPrescriptionDocumentWithTelematikInfrastructureInput!
  ) {
    de_signTherapyPrescriptionDocumentWithTelematikInfrastructure(input: $input) {
      de_TherapyPrescription {
        id
        signedAt
        signedBy
        fileId
        ...deTherapyPrescriptionFragment
      }
      errors {
        __typename
        ... on Error {
          message
        }
        ... on SignDocumentMutationFailed {
          errorType
        }
      }
    }
  }
`

type Config = Omit<
  UseMutationConfig<useDeSignTherapyPrescriptionWithTelematikInfrastructureMutationType>,
  "variables"
> & {
  id: De_signTherapyPrescriptionDocumentWithTelematikInfrastructureInput["id"]
}

const useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation = () => {
  const [commit, isFlight] =
    useMutationWithErrorDialog<useDeSignTherapyPrescriptionWithTelematikInfrastructureMutationType>(
      mutation,
      TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS,
    )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation }
